// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteCompanyEmailDomainMutationVariables = Types.Exact<{
  deleteCompanyEmailDomainId: Types.Scalars['ID']['input'];
}>;

export type DeleteCompanyEmailDomainMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteCompanyEmailDomain'
>;

export const DeleteCompanyEmailDomainDocument = /*#__PURE__*/ gql`
    mutation DeleteCompanyEmailDomain($deleteCompanyEmailDomainId: ID!) {
  deleteCompanyEmailDomain(id: $deleteCompanyEmailDomainId)
}
    `;
export type DeleteCompanyEmailDomainMutationFn = Apollo.MutationFunction<
  DeleteCompanyEmailDomainMutation,
  DeleteCompanyEmailDomainMutationVariables
>;

/**
 * __useDeleteCompanyEmailDomainMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyEmailDomainMutation, { data, loading, error }] = useDeleteCompanyEmailDomainMutation({
 *   variables: {
 *      deleteCompanyEmailDomainId: // value for 'deleteCompanyEmailDomainId'
 *   },
 * });
 */
export function useDeleteCompanyEmailDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCompanyEmailDomainMutation, DeleteCompanyEmailDomainMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCompanyEmailDomainMutation, DeleteCompanyEmailDomainMutationVariables>(
    DeleteCompanyEmailDomainDocument,
    options,
  );
}
export type DeleteCompanyEmailDomainMutationHookResult = ReturnType<typeof useDeleteCompanyEmailDomainMutation>;
export type DeleteCompanyEmailDomainMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyEmailDomainMutation,
  DeleteCompanyEmailDomainMutationVariables
>;
